import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from "../../services/loader.service";

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
  constructor(private readonly loader: LoaderService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Ignore auth bootstrap noise if you want (optional). Keeping it simple for now.
    this.loader.displayLoader(true);

    return next.handle(req).pipe(
      finalize(() => {
        this.loader.displayLoader(false);
      }),
    );
  }
}
